import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { FiShoppingBag } from 'react-icons/fi';
import useFetchData from '../../../hooks/useFetchData';

const TodaySales = () => {

    const date = new Date();
    const today = format(date, "yyyy-MM-dd");

    const { items: sales } = useFetchData("https://servers.thakurgaonexpress.com/rupkotha/getcurrentmonthsales");

    const totalSales = Array.isArray(sales) ? sales.filter(sale => sale?.day === today) : [];


    //style={{width:'300px',height:'120px'}}
    return (
        // <div class="mx-auto w-11/12 bg-coral text-textPrimary rounded-lg overflow-hidden bg-[#FDECEC] shadow-lg glassmorphism p-5">
        <div class="modern-card p-5">
            <div className='flex justify-between items-center'>
                <div class="flex flex-col justify-center items-center">
                    <div class="text-sm font-semibold mb-2">Today Sale</div>
                    <p class="text-xl text-textPrimary">৳ {totalSales?.length ? (totalSales[0]?.sales).toFixed(2) : 0.00}</p>
                </div>
                <div className="dashboard-stat-card__icon"><FiShoppingBag /></div>
            </div>
        </div>


    );
};

export default TodaySales;
